import Validator from 'validatorjs';

export const isEmail = (value) => {
  const validator = new Validator({ email: value }, { email: 'email|required' });
  const passed = validator.passes();
  
  return passed;
};